import React from 'react';

import infoIcon from 'assets/sidebar-info.svg';

const SidebarInfoIcon = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}): JSX.Element => (
  <img
    src={infoIcon}
    alt="info-icon"
    className={className}
    onClick={() => onClick()}
  />
);

export default SidebarInfoIcon;
